import React from "react";
import { Reveal } from "@/components/anim";
import { STATS } from "@/data/content";

const DROUGHT = "https://images.pexels.com/photos/36767372/pexels-photo-36767372.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function TexasWaterOpportunity() {
  return (
    <section id="opportunity" data-testid="opportunity-section" className="bg-bg-dark py-28 md:py-40 relative">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">The Water Opportunity</p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white leading-none max-w-4xl">
            A region running dry — and racing to build new supply.
          </h2>
          <p className="mt-6 max-w-2xl text-white/60 text-base md:text-lg leading-relaxed">
            Across the U.S. South and West, a widening gap between water demand and supply is accelerating — driven by
            record population growth, industrial expansion, and AI data-center demand. Reverse osmosis is the only
            long-term, drought-proof solution at scale.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {STATS.map((s, i) => {
            const feature = s.tone === "feature";
            const span = feature ? "md:col-span-8 md:row-span-2" : "md:col-span-4";
            return (
              <Reveal key={i} delay={i * 0.06} className={`${span} relative`}>
                <div
                  className={`relative h-full min-h-[180px] p-8 md:p-10 flex flex-col justify-between overflow-hidden ${
                    feature ? "bg-brand-navy" : "bg-bg-dark"
                  }`}
                >
                  {feature && (
                    <>
                      <img src={DROUGHT} alt="Drought-stricken land" className="absolute inset-0 h-full w-full object-cover opacity-25" />
                      <div className="absolute inset-0 bg-brand-navy/60" />
                    </>
                  )}
                  <div className="relative">
                    <div
                      className={`font-heading font-extrabold tracking-tighter leading-none ${
                        feature ? "text-6xl md:text-8xl text-white" : "text-5xl md:text-6xl"
                      } ${s.tone === "red" ? "text-brand-red" : s.tone === "teal" ? "text-brand-teal" : "text-white"}`}
                    >
                      {s.value}
                    </div>
                  </div>
                  <p className={`relative mt-6 max-w-md ${feature ? "text-white/85 text-base md:text-lg" : "text-white/55 text-sm"}`}>
                    {s.label}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-white/35 text-xs tracking-wide">
            Sources: U.S. Drought Monitor; regional water planning assessments across the U.S. South and West.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
